import NProgress from "nprogress";

export function resizeGridItem(item) {
    const grid = $(item).closest(".mg-grid")[0];

    if (!grid) return;

    const rowHeight = parseInt(
        window.getComputedStyle(grid).getPropertyValue("grid-auto-rows")
    );
    const rowGap = parseInt(
        window.getComputedStyle(grid).getPropertyValue("grid-row-gap")
    );
    const rowSpan = Math.ceil(
        (item.querySelector(".hentry").getBoundingClientRect().height +
            rowGap) /
            (rowHeight + rowGap)
    );
    item.style.msGridRowSpan = rowSpan;
    item.style.gridRowEnd = "span " + rowSpan;
}

export function resizeAllGridItems() {
    const allItems = document.getElementsByClassName("mg-grid__item");
    for (let x = 0; x < allItems.length; x++) {
        resizeGridItem(allItems[x]);
    }
}

function resizeInstance(instance) {
    const item = instance.elements[0];
    resizeGridItem(item);
}

export function checkGridAfterImagesLoaded() {
    const grid = document.querySelector(".mg-grid");
    if (grid) {
        NProgress.start();
        imagesLoaded(grid, NProgress.done);
    }

    const allItems = document.getElementsByClassName("mg-grid__item");
    for (let x = 0; x < allItems.length; x++) {
        imagesLoaded(allItems[x], resizeInstance);
    }
}

export default {
    resizeGridItem,
    resizeAllGridItems,
    checkGridAfterImagesLoaded
};



// WEBPACK FOOTER //
// ./src/js/utilities/grid-utilities.js